import {
  current_user_returned,
  users_returned,
  new_user_received,
  user_signed_out,
  set_user_profile,
  set_user_shoutouts_as_read,
  new_shoutout_received,
  shoutout_deleted,
  users_requested,
  user_updated
} from '../actions/types';

const INITIAL_STATE = {
  usersLoading: true,
  currentUser: null,
  role: '',
  users: [],
  userProfile: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case users_requested:
      return { ...state, usersLoading: true };

    case current_user_returned:
      return { ...state, currentUser: action.payload, role: action.payload.role || 'member' };

    case users_returned:
      return { ...state, users: [ ...action.payload ], usersLoading: false };

    case new_user_received:
      return { ...state, users: [ ...state.users, action.payload ] };

    case user_signed_out:
      return { ...INITIAL_STATE };

    case set_user_profile:
      return { ...state, userProfile: action.payload };

    case set_user_shoutouts_as_read: {
      let curr = state.currentUser;
      curr.unread = 0;
      return { ...state, currentUser: curr };
    }
    case new_shoutout_received: {
      let userIds = state.users.map((user) => user._id);
      let sender = state.users.filter((user) => user._id === action.payload.senderId)[0];
      let recipientIds = action.payload.recipients.map((user) => user._id);
      let recipients = state.users.filter((user) => recipientIds.indexOf(user._id) !== -1);

      let users = [ ...state.users ];

      sender.shoutoutsSent += 1;
      users[userIds.indexOf(sender._id)] = sender;
      recipients.forEach((user) => {
        user.shoutoutsReceived += 1;
        users[userIds.indexOf(user._id)] = user;
      });

      return { ...state, users };
    }
    case shoutout_deleted: {
      let userIds = state.users.map((user) => user._id);
      let users = [ ...state.users ];
      if (action.payload) {
        let sender = state.users.filter((user) => user._id === action.payload.senderId)[0];
        let recipientIds = action.payload.recipients.map((user) => user._id);
        let recipients = state.users.filter((user) => recipientIds.indexOf(user._id) !== -1);

        sender.shoutoutsSent -= 1;
        users[userIds.indexOf(sender._id)] = sender;
        recipients.forEach((user) => {
          user.shoutoutsReceived -= 1;
          users[userIds.indexOf(user._id)] = user;
        });
      }

      return { ...state, users };
    }
    case user_updated: {
      const { _id, bio, title } = action.payload;
      let user = state.users.filter((user) => user._id === _id)[0];
      user._id = _id;
      user.title = title;
      user.bio = bio;
      let users = state.users.filter((user) => user._id !== _id);
      return { ...state, users: [ ...users, user] };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/UsersReducer.js